import { Input, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { RESUME_SECTION_TYPES } from "../../../optimizeResume/editor/config";
import SectionCardShell from "../../../optimizeResume/editor/SectionCardShell";
import WriteWithAiSummaryModal from "../../modals/WriteWithAiSummaryModal";

const { TextArea } = Input;

export default function Summary({
  id,
  data,
  onChange,
  onDelete,
  allCollapsed,
  experiences,
  projects,
}) {
  const [value, setValue] = useState(data ?? "");
  const [aiModalOpen, setAiModalOpen] = useState(false);

  useEffect(() => {
    setValue(data ?? "");
  }, [data]);

  useEffect(() => {
    if (value !== data) onChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const aiButton = (
    <Tooltip
      overlayInnerStyle={{
        borderRadius: "6px",
        padding: "6px 10px",
        backgroundColor: "#0C111D",
        color: "#fff",
      }}
      title="Write with AI"
    >
      <div
        onClick={() => setAiModalOpen(true)}
        className="p-[.4rem] cursor-pointer text-[#DC6803] hover:text-amber-500 transition-all duration-200 border rounded-full border-[#FEDF89] bg-[#FFFAEB]"
      >
        {/* <svg
          width="14.2"
          height="14.2"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.70313 5.69922H3.70979M6.70313 5.69922H6.70979M9.70313 5.69922H9.70979M3.36979 10.6992V12.2562C3.36979 12.6115 3.36979 12.7891 3.44261 12.8803C3.50594 12.9596 3.60197 13.0058 3.70348 13.0057C3.82021 13.0056 3.95891 12.8946 4.2363 12.6727L5.8266 11.4004C6.15147 11.1405 6.3139 11.0106 6.49478 10.9182C6.65526 10.8362 6.82608 10.7763 7.0026 10.7401C7.20157 10.6992 7.40959 10.6992 7.82562 10.6992H9.50313C10.6232 10.6992 11.1833 10.6992 11.6111 10.4812C11.9874 10.2895 12.2934 9.98352 12.4851 9.6072C12.7031 9.17938 12.7031 8.61932 12.7031 7.49922V3.89922C12.7031 2.77911 12.7031 2.21906 12.4851 1.79124C12.2934 1.41491 11.9874 1.10895 11.6111 0.917206C11.1833 0.699219 10.6232 0.699219 9.50313 0.699219H3.90313C2.78302 0.699219 2.22297 0.699219 1.79514 0.917206C1.41882 1.10895 1.11286 1.41491 0.921112 1.79124C0.703125 2.21906 0.703125 2.77911 0.703125 3.89922V8.03255C0.703125 8.65253 0.703125 8.96252 0.771273 9.21686C0.956208 9.90704 1.4953 10.4461 2.18549 10.6311C2.43982 10.6992 2.74981 10.6992 3.36979 10.6992ZM4.03646 5.69922C4.03646 5.88331 3.88722 6.03255 3.70313 6.03255C3.51903 6.03255 3.36979 5.88331 3.36979 5.69922C3.36979 5.51512 3.51903 5.36589 3.70313 5.36589C3.88722 5.36589 4.03646 5.51512 4.03646 5.69922ZM7.03646 5.69922C7.03646 5.88331 6.88722 6.03255 6.70313 6.03255C6.51903 6.03255 6.36979 5.88331 6.36979 5.69922C6.36979 5.51512 6.51903 5.36589 6.70313 5.36589C6.88722 5.36589 7.03646 5.51512 7.03646 5.69922ZM10.0365 5.69922C10.0365 5.88331 9.88722 6.03255 9.70313 6.03255C9.51903 6.03255 9.36979 5.88331 9.36979 5.69922C9.36979 5.51512 9.51903 5.36589 9.70313 5.36589C9.88722 5.36589 10.0365 5.51512 10.0365 5.69922Z"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg> */}

        <Sparkles
          size={15}
          className=""
        />
      </div>
    </Tooltip>
  );

  return (
    <>
      <SectionCardShell
        id={id}
        type={RESUME_SECTION_TYPES.SUMMARY}
        data={data}
        onChange={onChange}
        onDelete={onDelete}
        allCollapsed={allCollapsed}
        extraActions={aiButton}
      >
        <TextArea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          autoSize={{ minRows: 4, maxRows: 10 }}
          placeholder="Enter your professional summary…"
        />
      </SectionCardShell>

      <WriteWithAiSummaryModal
        open={aiModalOpen}
        setOpen={setAiModalOpen}
        currentSummary={value}
        experiences={experiences}
        projects={projects}
        onApply={(aiText) => setValue(aiText)}
      />
    </>
  );
}
